import { NodeModel as NM, NodeModelGenerics } from '@projectstorm/react-diagrams';

export default class CommentNodeModel extends NM<NodeModelGenerics> {
  constructor(commentId) {
    super({ type: "NGComment", commentId });
  }
}
